import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';
import { useSites } from '@/hooks/useSites';
import type { PaidModule } from '@/hooks/useEntitlements';
import CheckoutDialog from './CheckoutDialog';

interface Props {
  module: PaidModule;
  compact?: boolean;
}

export const LockedModuleCard: React.FC<Props> = ({ module, compact }) => {
  const { sites } = useSites();
  const [open, setOpen] = useState(false);
  const facilityCount = Math.max(sites.length, 1);
  const pricePerFacility = module.price_per_facility_cents / 100;
  const monthlyTotal = pricePerFacility * facilityCount;

  return (
    <>
      <Card
        className={`bg-card border border-dashed rounded-xl ${
          compact ? 'p-4' : 'p-8'
        } flex flex-col items-center text-center gap-3`}
      >
        <div className="h-10 w-10 rounded-full bg-muted flex items-center justify-center">
          <Lock className="h-5 w-5 text-muted-foreground" />
        </div>
        <div>
          <h3 className="text-base font-semibold text-foreground">{module.name}</h3>
          <p className="text-xs text-muted-foreground max-w-md mt-1">{module.description}</p>
        </div>
        <p className="text-sm text-foreground tabular-nums">
          ${pricePerFacility.toLocaleString()} / facility / month
          <span className="text-muted-foreground">
            {' '}× {facilityCount} {facilityCount === 1 ? 'facility' : 'facilities'} ={' '}
          </span>
          <span className="font-semibold">${monthlyTotal.toLocaleString()} / mo</span>
        </p>
        <Button onClick={() => setOpen(true)} size="sm">
          Subscribe to unlock
        </Button>
      </Card>
      <CheckoutDialog
        open={open}
        onOpenChange={setOpen}
        request={{ kind: 'module', moduleKey: module.key, interval: 'month' }}
        title={`Subscribe to ${module.name}`}
        description="Charged per active facility. You can cancel any time."
      />
    </>
  );
};

export default LockedModuleCard;
